module.exports = __webpack_public_path__ + "static/assets/dc8cb58ef0a7e70cf3ed030c3621013e.png";